import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Transition } from "@headlessui/react";
import FaceScan from "../assets/images/FaceScan.webp";
import InstructionFaceScan1 from "../assets/images/instructions/face1.webp";
import InstructionFaceScan2 from "../assets/images/instructions/face2.webp";
import InstructionFaceScan3 from "../assets/images/instructions/face3.webp";
import InstructionFaceFingerScan from "../assets/images/instructions/face-finger.webp";

const instructions = [
  { img: InstructionFaceScan1, desc: "The ambient light should be bright, consistent, and white." },
  { img: InstructionFaceScan2, desc: "Remove any face-obstructing items, such as your mask, eyewear, or clothing." },
  { img: InstructionFaceScan3, desc: "Keep your face and phone steady to avoid movements during the scan." },
  { img: InstructionFaceFingerScan, desc: "If prompted, allow the camera permission." },
];

const ScanInstructions = () => {
  const { state } = useLocation();
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentStep((s) => (s + 1) % instructions.length);
    }, 3000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <section className="p-8">
      <div className="flex items-center justify-between space-x-4">
        <h2 className="text-2xl font-semibold">
          How to do a<br />
          <span className="text-secondary">Face Scan</span>?
        </h2>
        <img className="shrink-0 h-28 rounded-full border-4 border-dotted border-white" src={FaceScan} alt="Instruction" />
      </div>

      <div className="relative mt-8 flex flex-nowrap">
        {instructions.map((ins, idx) => (
          <Transition
            key={`instruction-${idx + 1}`}
            show={currentStep === idx}
            enter="transform transition ease-in-out duration-1000"
            enterFrom="translate-x-96 opacity-0"
            enterTo="translate-x-0 opacity-100"
            leave="transform transition ease-in-out duration-1000 "
            leaveFrom="translate-x-0 opacity-100"
            leaveTo="-translate-x-96 opacity-0"
            className="w-0 overflow-visible">
            <div style={{ width: `calc(100vw - 4rem)` }}>
              <img className="h-48 w-full object-fill rounded-2xl border-2 border-secondary" src={ins.img} alt={`Instruction Banner ${idx + 1}`} />
              <p className="mt-12 text-center leading-snug">{ins.desc}</p>
            </div>
          </Transition>
        ))}
        <div className="absolute top-[13.5rem] left-0 right-0 flex items-center justify-center space-x-2">
          {instructions.map((_, idx) => (
            <div key={`instruction-bubble-${idx + 1}`} className={`h-2 w-2 rounded-full ${currentStep === idx ? "bg-secondary" : "bg-white"}`} />
          ))}
        </div>
      </div>

      <Link
        className="mt-6 w-full flex items-center justify-center space-x-4 rounded-full outline-none px-5 py-2.5 bg-gradient disabled:opacity-50 text-white"
        to="/face-scan"
        replace
        state={{ ...state }}>
        Understood, Let's Start
      </Link>

      <div className="mt-6 p-4 rounded-xl bg-gradient-transparent text-white space-y-1.5">
        <h3 className="text-xs font-medium">Disclaimer</h3>
        <p className="text-xxs text-justify">
          For Investigational Use Only. CarePlix is not a substitute for the clinical judgment of a healthcare professional. CarePlix is intended to
          improve your awareness of general wellness. CarePlix does not diagnose, treat, mitigate or prevent any disease, symptom, disorder or
          abnormal physical state. Consult with a healthcare professional or emergency services if you believe you may have a medical issue.
        </p>
      </div>
    </section>
  );
};

export default ScanInstructions;
